import { FC, useContext } from "react";
import { SimpleGrid, Stack } from "@mantine/core";
import { TeamCard } from "../../../../Components/TeamCard";
import { CenteredLoader } from "../../../../Components/CenteredLoader";
import { CompetitionContext } from "../../../../CompetitionContext.tsx";
import { useCompetition } from "../../../../hooks/useCompetition.ts";
import { PageTitle } from "../../../../Components/PageTitle";
import { IconUsers } from "@tabler/icons-react";
import { getPresentationParamsForOrigin } from "../../../../getPresentationParamsForOrigin.ts";

export const TeamsPage: FC = () => {
  const competitionId = useContext(CompetitionContext);
  const competitionData = useCompetition(competitionId);

  return (
    <Stack gap="lg" mt="md">
      <PageTitle
        icon={<IconUsers size={24} />}
        metaDescription={`Alle teilnehmenden Mannschaften beim ${getPresentationParamsForOrigin().competitionName}.`}
      >
        Mannschaften
      </PageTitle>
      {competitionData.isSuccess ? (
        <SimpleGrid cols={2} spacing="md">
          {competitionData.data.teamIds.map((t) => (
            <TeamCard key={t} teamId={t} to={t} />
          ))}
        </SimpleGrid>
      ) : (
        <CenteredLoader />
      )}
    </Stack>
  );
};
